import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

const LeavemeetingButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant, leaveMeeting } = rootStore.tenantStore;
  const { attendingMeeting } = rootStore.playerStore;
  const { leaveSession, toggleIsBroadcastControllerOpen, broadcastLauncherTypes } = rootStore.broadcastStore;
  const {setSourceId, updateDocumentalView} = rootStore.meetingStore
  const [t] = useTranslation(["translation"], translationHookOptions);

  const { isMobileMediaQuery, setIsSidebarModalOpen, isSidebarModalOpen } = rootStore.responsiveStore;
  const leaveMeetingFunction = async (id:number) =>{
    leaveMeeting(id)
    setSourceId(null)
    if(broadcastLauncherTypes){
      await leaveSession();
      toggleIsBroadcastControllerOpen(false);
    }
  }

  return (
    <>
      {attendingMeeting && currentTenant && (
        <>
          <Button
          style={{marginRight : isMobileMediaQuery ? "2%" : "0"}}
            id="btnLeaveMeeting"
            color=""
            // onClick={() => leaveMeeting(attendingMeeting.id)}
            onClick={() => leaveMeetingFunction(attendingMeeting.id)}
            className="navbarButton navbarButtonEnabled"
          >
            <span className="font-size-80 font-weight-bold mr-2 d-none d-lg-inline-block">
              {t("navbar_leave_button")}
            </span>
            <i className={"fas fa-sign-out-alt align-middle fa-lg"}></i>
          </Button>
        </>
      )}
    </>
  );
};

export default observer(LeavemeetingButton);
